import { FC, ReactNode } from 'react'
import cn from 'classnames'
import { useHistory } from 'react-router-dom'

import { ReactComponent as Spinner } from '@src/assets/spinner.svg'
import style from '@src/components/Button/Button.module.scss'
import { ReactComponent as Arrow } from '@src/assets/arrow_back.svg'

type ButtonProps = {
  className?: string
  outline?: boolean
  type?: 'primary' | 'secondary' | 'text' | 'textSecondary'
  disabled?: boolean
  icon?: ReactNode
  loading?: boolean
  url?: string
}

export const ReturnBtn: FC<ButtonProps> = ({
  children,
  className,
  disabled,
  outline,
  type = 'primary',
  icon,
  loading,
  url,
}) => {
  const history = useHistory()

  return (
    <button
      type="button"
      className={cn(style.btn, style.returnBtn, style[type], outline && style.outline, className)}
      disabled={disabled || loading}
      onClick={!url ? () => history.goBack() : () => history.push(url)}
    >
      {icon || <Arrow />}
      <div>{children}</div>
      {loading && <Spinner className={style.spinner} />}
    </button>
  )
}
